export class Location {
  constructor () {}
  locationId: any = '';
  name: any = '';
  province: any = '';
}
